import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updadteHeightTore, updateWidthTore, updateStepsTore} from '../../../../store/actions/tore';
import TextField from '@material-ui/core/TextField';
import scrollToElement from '../../../../module/scrollToElement';


const Step_2 = (props) => {
   const [height, updateHeight] = useState(0);
   const [width, updateWidth] = useState(0);


   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      const {height, width} = props.data[props.modell_index].dimensions[0];

      updateHeight(height);
      updateWidth(width);

      //scroll to Next Button Container
      scrollToElement();

      //update steps
      props.updateStepsTore(1);
      if(height && width) props.updateStepsTore(2);

      if((height && width) || props.data[props.modell_index].allVisitedSteps) {
         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue()
      }


   }

   const updadteHeightTore = ev => {
      props.updadteHeightTore(ev.target.value);
      updateItems();
   }

   const updateWidthTore = ev => {
      props.updateWidthTore(ev.target.value);
      updateItems();
   }

   let titel = props.data[props.modell_index].modell[0].kind;

   return (
       <div className="step_wrapper">
             <h2 className="step_header">Wie sind Ihre Maße für das {titel}?</h2>
              <div className="step_icon_wrapper">
                 <div className="inner_masseMenge_wrapper">
                  <div className="textfield-wrapper">
                        <TextField
                           className="textfield-masse-quantity"
                           label="Breite (in cm)"
                           type="number"
                           rowsMax={1}
                           value={width}
                           name="width"
                           onChange={updateWidthTore}
                        >
                     </TextField>
                     <TextField
                           className="textfield-masse-quantity"
                           label="Höhe (in cm)"
                           type="number"
                           rowsMax={1}
                           value={height}
                           name="height"
                           onChange={updadteHeightTore}
                        >
                     </TextField>
                  </div>
                </div>
            </div>
          </div>
   )
}

const mapStateToProps = state => {
    return {
      data: state.toreReducer.data,
      modell_index: state.toreReducer.modell_index
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updadteHeightTore: ev => dispatch(updadteHeightTore(ev)),
      updateWidthTore: ev => dispatch(updateWidthTore(ev)),
      updateStepsTore: ev => dispatch(updateStepsTore(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_2);
